module.exports = __webpack_public_path__ + "img/1582660383.51b54b39.jpg";